import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Validators, FormControl, UntypedFormGroup, UntypedFormBuilder } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AppRouterService } from 'src/app/core/services/app-router.service';
import { SessionService } from 'src/app/core/services/session.service';
import { ToastController, LoadingController, IonRouterOutlet, ModalController } from '@ionic/angular';
import { Storage } from '@ionic/storage';
import { HelperService } from 'src/app/core/services/helper.service';
import { MultiFactorComponent } from 'src/app/shared/modals/multi-factor/multi-factor.component';
import { VendorBackendService } from 'src/app/core/services/vendor-services/vendor-backend.service';


@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class LoginComponent implements OnInit {

  loginform: UntypedFormGroup;
  password = true;
  showLoginTryHere: boolean;

  constructor(
    private title: Title,
    private fb: UntypedFormBuilder,
    private sessionService: SessionService,
    // private sessionService: VendorSessionService,
    private appRouter: AppRouterService,
    public toastController: ToastController,
    public loadingController: LoadingController,
    public storage: Storage,
    public router: Router,
    public helperService: HelperService,
    private vendorBackendService: VendorBackendService,
    private modalCtrl: ModalController,
    private routerOutlet: IonRouterOutlet,
  ) { }

  ngOnInit(): void {
    this.title.setTitle('eZintegrations | Vendor Login');
    this.password = true;
    this.loginform = this.fb.group({
      'email': ['', Validators.required],
      'password': ['', Validators.required],
      'remember': [false],
      'code': []
    });
    // this.sessionService.clearStorage();
    // this.getAllSystemConfig()
  }

  // ionViewWillEnter() {
  //   this.getAllSystemConfig()
  // }

  // getAllSystemConfig() {
  //   this.getStorage().then((res) => {  
  //     this.vendorBackendService.GetAPICall('getAllConfig', res.token).subscribe(
  //       (data) => {
  //         //console.log(data[0].id, data[0])
  //         if (data[0].id === 1 && data[0].config_name === "SHOW_REGISTER") {
  //           this.showLoginTryHere = data[0].config_value == "1"; // Set showLoginTryHere based on config_value
  //           //console.log("showLoginTryHere:", this.showLoginTryHere);
  //         }
  //         this.helperService.closeLoader();    
  //       },
  //       (error) => {
  //         //console.log(error);
  //         this.helperService.closeLoader();
  //         this.helperService.presentToast(error.error.msg, 2000);
  //       }
  //     );
  //   });
  // }

  get f() { return this.loginform.controls; }

  async getStorage() {
    let data = {
      token: await this.storage.get("token"),
      showDialog: await this.storage.get("showDialog")
    }
    return data;
  }

  onSubmitlogin(code?) {
    if (this.loginform.invalid) {
      return;
    }
    this.loginform.patchValue({
      email: this.loginform.value.email.trim(),
      password: this.loginform.value.password.trim(),
      code: code
    })
    this.vendorBackendService.Post('login', this.loginform.value)
      .subscribe(
        data => {
          if(!data.isPwdExpired){
            if (data && data.token) {
              data.role_id = 50;
              this.sessionService.setStorageDetails(data, this.loginform.value.remember);
              this.appRouter.gotoPath('vendor/baseapp/dashboard');
            }
            if (data && data.msg) {
              this.helperService.presentToast(data.msg, 2000);
              return;
            }
          }else{
            this.sessionService.setStorageDetails("resetPwd", this.loginform.value.remember, data);
            this.router.navigate(['vendor/reset-password']);
          }
          

        },
        err => {
          if (err.error.detail == 'MFA code is required for this user') {
            this.openSchedular();
          }
          this.helperService.presentToast(err.error.detail, 3000);
        }
      );
  }
  async openSchedular() {
    // let data = this.summary.controls["schedule"].value;
    const modal = await this.modalCtrl.create({
      component: MultiFactorComponent,
      componentProps: {
        "Data": "mfa"
      },
      cssClass: 'my-custom-class',
      swipeToClose: true,
      backdropDismiss: true,
      presentingElement: this.routerOutlet.nativeEl
    });
    modal.onDidDismiss().then(res => {
      if (res != undefined && res != null) {
        this.onSubmitlogin(res.data.otp)
      }
    })
    return await modal.present();
  }
}